import { render } from "./ArticleListPage.vue?vue&type=template&id=373162d4"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__